import apolloClient from '../../apolloClient';
import modelsQueries from 'src/gql/queries/model';
import modelsMutation from 'src/gql/mutations/model';

const getModels = async (variables) =>
  apolloClient.query({
    query: modelsQueries.GET_MODELS,
    fetchPolicy: 'no-cache',
    variables,
  });

const createModel = async (variables) =>
  apolloClient.mutate({
    mutation: modelsMutation.CREATE_MODEL,
    fetchPolicy: 'no-cache',
    variables,
  });

const updateModelById = async (variables) =>
  apolloClient.mutate({
    mutation: modelsMutation.UPDATE_MODEL_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const deleteModelById = async (variables) =>
  apolloClient.mutate({
    mutation: modelsMutation.DELETE_MODEL_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  // getModelById,
  getModels,
  updateModelById,
  createModel,
  deleteModelById,
};
